/**
 * Created by Ning Jiang on 11/22/2016.
 */

/*
⡿⠿⠿⠿⠿⠻⠿⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡇
⣧⣡⣤⡴⠖⣒⣂⠄⡉⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡇
⣿⣿⡇⢴⡌⡀⢨⣤⡡⣨⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡇
⣿⣿⣿⣦⣄⡀⢸⣿⡇⣿⣿⣿⡟⢻⣿⣿⣿⣿⣿⡿⠟⠛⠿⠿⠿⣿⣿⣿⣿⡇
⣿⣿⣿⣿⣿⣿⣷⣶⣾⣿⣿⣿⣿⡆⣿⣿⠏⣠⣶⣦⣤⡤⠤⠤⣤⣀⣀⠈⢻⡇
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⠂⣿⡏⢠⣿⣿⣿⢡⣬⠉⣑⠂⠉⠻⣿⣿⡇
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠃⣰⣿⣧⡀⠻⢿⣯⣷⣭⣀⡈⠄⣿⣷⣦⡻⡇
⣿⣿⣿⣿⣿⣿⣿⠿⠋⠉⣉⣉⠄⠹⠋⢀⣀⣴⣶⣄⡈⠻⣿⣿⣿⣶⣶⣦⣵⡆
⣿⣿⣿⣿⣿⡟⢁⠴⣩⠾⠋⠉⠉⠉⠉⠉⠄⠄⠈⠙⠿⣦⡈⢿⣿⣿⣿⣿⣿⡇
⣿⣿⣿⣿⣿⣇⣺⣿⠁⠄⠄⠄⢀⣀⣀⣀⣀⣀⡀⠄⠄⠈⢿⣾⠿⣿⣿⣿⣿⡇
⣿⣿⣿⣿⣿⠋⣽⣅⣴⣎⠠⠔⣂⣖⣆⣒⣖⡢⠶⠶⡢⢄⠄⢿⣧⡈⠻⢿⣿⡇
⣿⣿⣿⡏⢹⡄⣿⣿⣿⣿⡿⠗⠂⠠⠠⠠⢭⣩⣭⣭⣴⣿⣷⣾⣿⡇⠄⣤⣀⡇
⣿⣿⣿⣧⣤⡿⢻⣿⣿⣿⣦⣄⣤⡀⠄⠄⢠⣿⣿⣿⣿⣿⣿⡟⡿⡀⣾⡿⠛⡁
⣿⣿⣿⠿⠏⠄⠄⠘⠻⣿⣿⣿⣿⣿⣿⣧⣼⣿⣿⣿⣿⣿⣿⡿⠄⠄⠫⣠⣾⡇
⠿⠿⠇⠄⠄⠄⠄⠄⠄⠾⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠿⠋⠄⠄⠄⠄⠹⠿⠇
*/

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {DecadenceGameAssets} from "./DecadenceGameAssets";
import {DecadenceSound} from "./sound/DecadenceSound";
import {DecadenceData, DecadenceGameData} from "./server/DecadenceData";
import {DecadenceModel} from "./server/DecadenceModel";
//import {Speedster} from "./debug/Speedster";
import {SkateOrDieBackgroundElements} from "./views/SkateOrDieBackgroundElements";
import {DecadenceForegroundElements} from "./views/DecadenceForegroundElements";
import {DecadenceIdleFlow} from "./gameflow/DecadenceIdleFlow";
import {DecadenceReelsView} from "./views/DecadenceReelsView";
import {DecadanceWinCounterView} from "./views/DecadanceWinCounterView";
import {SkateOrDieTransitionScreenView} from "./views/SkateOrDieTransitionScreenView";
import {DecadenceBetFlow} from "./gameflow/DecadenceBetFlow";
import {DecadenceWinFlow} from "./gameflow/DecadenceWinFlow";
import {DecadenceReelStopFlow} from "./gameflow/DecadenceReelStopFlow";
import {DecadenceZeroBetIdleFlow} from "./gameflow/DecadenceZeroBetIdleFlow";
import {Speedster} from "./debug/Speedster";
import {SpinePreviewer} from "./debug/SpinePreviewer";
import {DecadenceSymbol} from "./symbols/DecadenceSymbol";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {DecadenceReelSelectView} from "./views/DecadenceReelSelectView";
import {DecadenceStatics} from "./config/DecadenceStatics";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";

//import {SpinePreviewer} from "./debug/SpinePreviewer";


export class Decadence extends SlotGame {
    public static model:DecadenceModel;
    public static assetLoader:AssetLoader;
    public static soundPlayer:DecadenceSound;
    public static backgroundElements:SkateOrDieBackgroundElements;
    public static foregroundElements:DecadenceForegroundElements;
    public static gameFlowController:GameFlowController;
    public static reelView:DecadenceReelsView;
    public static transitionScreen:SkateOrDieTransitionScreenView;
    public static winCounter:DecadanceWinCounterView;
    public static reelSelectView:DecadenceReelSelectView;

    constructor() {
        super();
    }

    private static getAccumulatedRoundWin(): number {
        return Decadence.model.data.accumulatedRoundWin;
    }

    getNoWinGameData():any {
        return {
            "reels": ["0", "0", "0", "0"],
            "evaluatedArea": ["0", "0", "0", "0"],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "wasFeatureBuy": false,
            "brokeTheBank": false,
            "totalNumberOfWays": 1,
            "thisSpinWinning": 0,
            "waysWonTotalRound": 0,
            "freeSpinType": 0,
            "enhancedBet": false,
            "wildLanded": false,
            "winMultiplier": 1
        }
    }

    public init():Promise<NolimitPlugin> {
        return super.init().then((value:NolimitPlugin) => {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            // Hack to enable scissor system
            (<any>NolimitApplication.pixiApp.renderer.mask.enableScissor) = true;

            Decadence.model = new DecadenceModel(SlotGame.apiPlugin, true);
            Decadence.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Decadence.model);
            Decadence.gameFlowController.flowStateLogger.level = LogLevel.DEV;


            //Example
            Decadence.model.events?.on(GameModelEvent.GAME, (data:DecadenceGameData) => {
                console.log(data);
            });

            const winFlow = new DecadenceWinFlow();
            const idleFlow = new DecadenceIdleFlow();
            const reelStart = new DecadenceBetFlow();
            const normalResult = new DecadenceReelStopFlow();
            const zeroBetIdle = new DecadenceZeroBetIdleFlow();

            Decadence.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleFlow],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winFlow]
            ]));
            Decadence.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.RESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winFlow]
            ]));
            Decadence.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winFlow]
            ]));

            Decadence.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winFlow]
            ]));

            Decadence.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, (data:any) => {
                if(Decadence.model.isRestore) {
                    // Restore keypad win here since then active bet feature is set
                    Decadence.keypadPlugin.setWin(Decadence.model.initData.accumulatedRoundWin, true, Decadence.model.winBelowStake);
                    return;
                }

                const activeFeature = Decadence.apiPlugin.betFeatureController.getActiveBetFeature();
                if(activeFeature) {
                    switch (activeFeature.name) {
                        case "REELS_2":
                        case "FREESPIN_REELS_2":
                        case "SUPER_FREESPIN_REELS_2":
                            Decadence.reelView.set2ReelMode();
                            break;
                        case "REELS_4":
                        case "FREESPIN_REELS_4":
                        case "SUPER_FREESPIN_REELS_4":
                            Decadence.reelView.set4ReelMode();
                            break;
                        case "SUPER_FREESPIN":
                        case "FREESPIN":
                            Decadence.reelView.set1ReelMode();
                            break;
                        case "GOD_MODE":
                            Decadence.reelView.set1ReelMode();
                            break;
                    }
                    Decadence.reelView.setReelSetFromMode(activeFeature.name);
                } else {
                    Decadence.reelView.set1ReelMode();
                    Decadence.reelView.setReelSetFromMode("NORMAL");
                }
                Decadence.reelSelectView.setButtonStatesFromFeature(activeFeature?.name);

                Decadence.reelSelectView.setButtonStatesFromFeature(activeFeature?.name);
            });

            // Free Bets and Free feature bets
            Decadence.apiPlugin.freeBets.events.on(Decadence.apiPlugin.freeBets.FREE_BETS_START, () => {
                Decadence.reelSelectView.lockButtons();
            });
            Decadence.apiPlugin.promotionHandler.events.on(Decadence.apiPlugin.promotionHandler.FREE_BETS_END, () => {
                Decadence.reelSelectView.unlockButtons();
            });

            Decadence.apiPlugin.promotionHandler.events.on(Decadence.apiPlugin.promotionHandler.FREE_FEATURE_BET_START, () => {
                Decadence.reelSelectView.lockButtons();
            })
            Decadence.apiPlugin.promotionHandler.events.on(Decadence.apiPlugin.promotionHandler.FREE_FEATURE_BET_END, () => {
                Decadence.reelSelectView.unlockButtons();
            })

            return value;
        });
    }

    public getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value:NolimitPlugin) => {
            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(DecadenceGameAssets.RESOURCES_GROUPS);
            Decadence.assetLoader = new AssetLoader(Decadence.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), Decadence.assetLoader.load(ResourcesGroupName.MAIN)]);


            return promises.then((values:any) => {
                this.createViewsAndComponents();

                return value;
            });
        });
    }

    public getReadyToStart():Promise<NolimitPlugin> {
        Decadence.soundPlayer.switchMusic("NORMAL");
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value:NolimitPlugin) => {
            return value;
        });
    }

    public start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value:NolimitPlugin) => {
            Decadence.gameFlowController.start();
            Decadence.soundPlayer.switchMusic(Decadence.model.mode);
            if (!Decadence.model.isRestore && !Decadence.apiPlugin.isReplay) {
                Decadence.soundPlayer.playSound("continueButton");
                //Exorcism.foregroundElements.showGameIntro();
            }

            if(!Decadence.model.isRestore && !Decadence.apiPlugin.freeBets.hasFreeBets() && !Decadence.apiPlugin.promotionHandler.hasFreeFeatureBet()) {
                Decadence.reelSelectView.unlockButtons();
            }
            return value;
        });
    }

    private createViewsAndComponents() {
        //Non views
        Decadence.soundPlayer = new DecadenceSound();

        //Static views
        Decadence.backgroundElements = new SkateOrDieBackgroundElements();
        Decadence.reelView = new DecadenceReelsView();
        Decadence.foregroundElements = new DecadenceForegroundElements();
        Decadence.transitionScreen = new SkateOrDieTransitionScreenView();
        Decadence.winCounter = new DecadanceWinCounterView();
        Decadence.reelSelectView = new DecadenceReelSelectView();

        //NolimitApplication.addLayerAt("Spine Previewer", new SpinePreviewer(Possessed.assetLoader));
        NolimitApplication.addLayer("Speedster", new Speedster());
        NolimitApplication.addLayerAt("Spine Viewer", new SpinePreviewer(Decadence.assetLoader, DecadenceGameAssets));
        NolimitApplication.addLayerAt(Decadence.winCounter.name, Decadence.winCounter, 0);
        NolimitApplication.addLayerAt(Decadence.foregroundElements.name, Decadence.foregroundElements, 0);
        NolimitApplication.addLayerAt(Decadence.transitionScreen.name, Decadence.transitionScreen, 0);
        NolimitApplication.addLayerAt(Decadence.reelSelectView.name, Decadence.reelSelectView, 0);
        NolimitApplication.addLayerAt(Decadence.reelView.name, Decadence.reelView, 0);
        NolimitApplication.addLayerAt(Decadence.backgroundElements.name, Decadence.backgroundElements, 0);

        if(Decadence.model.isRestore) {
            Decadence.reelView.onRestore();
            Decadence.reelSelectView.onRestore();
            Decadence.backgroundElements.onRestore();
            if(!Decadence.model.initData.wasFeatureBuy && !Decadence.model.initData.boostedBet) {
                Decadence.keypadPlugin.setWin(Decadence.model.initData.accumulatedRoundWin, true, Decadence.model.winBelowStake);
            }
        }

        // Make sure the reel select button can not be clicked during intro splash
        Decadence.reelSelectView.lockButtons();

        // Handle restore state
        //if(Possessed.model.isRestore) {
        //    SlotGame.keypadPlugin.setWin(Possessed.model.initData.accumulatedRoundWin, true, Possessed.model.isWinBelowStake());
        //    Possessed.crucifixReel.onRestore();
        //    Possessed.reelView.onRestore();
        //    Possessed.reelView.reelCross.onRestore();
        //    Possessed.backgroundElements.onRestore();
        //}
    }

    getPaytable(): Promise<string> {
            const allowedFeatures = Decadence.apiPlugin.betFeatureController.getAllowedFeatures();

            const reel2Features = [
                    "REELS_2", "FREESPIN_REELS_2", "SUPER_FREESPIN_REELS_2"
            ];
            const reel4Features = [
                "REELS_4", "FREESPIN_REELS_4", "SUPER_FREESPIN_REELS_4"
            ];
            const multipleReelsFeatures = [
                ...reel2Features,
                ...reel4Features
            ];
            const multipleReelsAllowed:boolean = allowedFeatures.some(allowed  => multipleReelsFeatures.includes(allowed.name));
            const reels2Allowed:boolean = allowedFeatures.some(allowed => reel2Features.includes(allowed.name));
            const reels4Allowed:boolean = allowedFeatures.some(allowed => reel4Features.includes(allowed.name));

            const flagData = {
                boostedBetAllowed: Decadence.apiPlugin.gameClientConfiguration.boostedBetAllowed,
                replaceWincapInfo: Decadence.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                multipleReelsAllowed,
                reels2Allowed,
                reels4Allowed,
            }
            return super.getPaytable().then((value: string) => {
                let translatedContent: string = Decadence.apiPlugin.translations.render(value,flagData);
                return translatedContent;
            });
    }

    getGameRules(): Promise<string> {
        const allowedFeatures = Decadence.apiPlugin.betFeatureController.getAllowedFeatures();

        const reel2Features = [
            "REELS_2", "FREESPIN_REELS_2", "SUPER_FREESPIN_REELS_2"
        ];
        const reel4Features = [
            "REELS_4", "FREESPIN_REELS_4", "SUPER_FREESPIN_REELS_4"
        ];
        const multipleReelsFeatures = [
            ...reel2Features,
            ...reel4Features
        ];
        const multipleReelsAllowed:boolean = allowedFeatures.some(allowed  => multipleReelsFeatures.includes(allowed.name));
        const reels2Allowed:boolean = allowedFeatures.some(allowed => reel2Features.includes(allowed.name));
        const reels4Allowed:boolean = allowedFeatures.some(allowed => reel4Features.includes(allowed.name));

        // Fetch active DX
        let gameName = Decadence.apiPlugin.options.game;
        if(gameName == "MunchiesDX3") gameName = "Munchies";

        // Hardcoded list of max win probabilities for different reels and DX
        const maxWinProbTable:{[key:string]:{[key:number]:string}} = {
            //DX            , {Reels : Probability}
            "Munchies":     {1: "445494", 2: "324781", 4: "131026"},
            "MunchiesDX1":  {1: "454298", 2: "331719", 4: "135029"},
            "MunchiesDX2":  {1: "462000", 2: "335166", 4: "138061"},
            "MunchiesDX4":  {1: "506920", 2: "375404", 4: "155790"},
        };
        const maxWinMultiplier:string = reels4Allowed ? "40000" : (reels2Allowed ? "20000" : "10000");

        const maxReelMode = reels4Allowed ? 4 : (reels2Allowed ? 2 : 1);
        const maxWinProb:string = maxWinProbTable[gameName][maxReelMode];

        const flagData = {
            boostedBetAllowed: Decadence.apiPlugin.gameClientConfiguration.boostedBetAllowed,
            replaceWincapInfo: Decadence.apiPlugin.gameClientConfiguration.replaceWincapInfo,
            showBaseGameHighestWinInRules: Decadence.apiPlugin.gameClientConfiguration.showBaseGameHighestWinInRules,
        };

        return super.getGameRules().then((value: string) => {
            let translatedContent: string = Decadence.apiPlugin.translations.render(value,flagData);
            let modified = translatedContent.replace(`<span class="maxMultiplier">-1</span>`, maxWinMultiplier);
            modified = modified.replace(`<span class="maxMultiplierProbability">-2</span>`, `1:${maxWinProb}`);
            return modified;
        });
    }
}